import { useEffect } from 'react'
import { useRef } from 'react'
import { useState } from 'react'

interface Props {
  fetchMore: () => void
}

export const useInfiniteScroll = ({ fetchMore }: Props) => {
  const [loaderElement, setLoaderElement] = useState<Element | null>(null)

  const observer = useRef(
    new IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting) fetchMore()
      }
    )
  )

  useEffect(() => {
    if (!loaderElement) return

    // Cache these two so the cleanup function doesn't fall over
    const e = loaderElement
    const o = observer.current

    o.observe(e)

    return () => o.unobserve(e)
  })

  return {
    setLoaderElement
  }
}
